import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import SmallBodyFont from '../../Theme/Fonts/SmallBody'
import Bet, { BetProps } from '../Bet'
import VoteCardHolder from './HelperClass/voteCardHolder'

export type VoteOption = {
    /**
     * team name on each card
     * */
    label: string
    /**
     * image Url for team logo
     * */
    imageUrl?: string
    /** info about imageUrl for seo */
    alt?: string
    /**
     * Vote Percent number displayed on Voted State
     * */
    percent?: number
    /**
     * display if the option was selected as a vote from user
     * */
    active: boolean
}
export type FanVotingProps = {
    /** Vote options which recieve an array of 3 vote objects */
    voteOptions: VoteOption[]
    /** title which shown on top of 3 cards */
    title?: string
    /** optional testID, */
    testID?: string
    /** Determines the component behavior, true goes for VotedState and false for initialstate, */
    hasVoted: boolean
    /**
     * Just in initialState, is a callback when each card clicked,it has index number of card as parameter
     * @TJS-type function
     * */
    onPress?: (selectedIndex: number) => void
    /**
     * properties to show odds for the related match
     */
    betProps?: BetProps
}

const FanVoting: FunctionComponent<FanVotingProps> = ({
    hasVoted,
    voteOptions,
    onPress,
    title = 'Wer wird gewinnen?',
    testID,
    betProps,
}) => {
    return (
        <Grid
            noExpand
            borderRadius={4}
            paddingTop={5}
            backgroundColor="pearl"
            border="1px"
            borderColor="moon-2"
            centerVertical
            overflow="hidden"
        >
            <SmallBodyFont bold textAlign="center">
                {title}
            </SmallBodyFont>

            <Grid noExpand horizontal marginTop={5} marginBottom={betProps ? 3 : 5} marginX={4}>
                {voteOptions.map((option, index, arr) => {
                    return (
                        <VoteCardHolder
                            marginRight={index !== arr.length - 1 ? 2 : undefined} //No marginRight for last box
                            marginLeft={index !== 0 ? 2 : undefined} //No marginLeft for first box
                            key={index}
                            cardValues={option}
                            testID={testID}
                            onPress={
                                !hasVoted && onPress
                                    ? (): void => {
                                          onPress(index)
                                      }
                                    : undefined
                            }
                        />
                    )
                })}
            </Grid>
            {betProps ? <Bet {...betProps} /> : null}
        </Grid>
    )
}

export default FanVoting
